






































































import moment from 'moment'
import { Component, Ref, Vue } from 'vue-property-decorator'
import ListView from '@/components/ListView.vue'
import ShopAutocomplete from '@/components/ShopAutocomplete.vue'
import DateSelect from '@/components/DateSelect.vue'
import CSVExportBtn from '@/components/CSVExport.vue'
import { formatDateForDisplay } from '@/utils'

@Component({
  components: {
    ListView,
    ShopAutocomplete,
    DateSelect,
    CSVExportBtn,
  },
})
export default class AdditionalReserveFrame extends Vue {
  filterDefinition = {
    shop: { type: String, default: null },
    dateFrom: { type: String, default: null },
    dateTo: { type: String, default: null },
  }
  @Ref() readonly listView!: ListView

  get staffLoggedIn(): boolean {
    return this.$store.getters.staffLoggedIn
  }
  get csvHeaders() {
    const t = this.$t.bind(this)
    return [
      { key: 'id', label: t('forceReservable.csv.id') },
      {
        key: (item: any) => item.shopCode,
        label: t('forceReservable.csv.shopCode'),
      },
      {
        key: (item: any) => item.shopName,
        label: t('forceReservable.csv.shopName'),
      },
      {
        key: (item: any) =>
          formatDateForDisplay(item.startAt, this.$i18n.locale),
        label: t('forceReservable.csv.date'),
      },
      {
        key: (item: any) => extractTime(item.startAt),
        label: t('forceReservable.csv.time'),
      },
    ]
  }

  get headers() {
    return [
      { text: this.$t('forceReservable.text.shopCode'), value: 'shopCode' },
      { text: this.$t('forceReservable.text.shopName'), value: 'shopName' },
      { text: this.$t('forceReservable.text.date'), value: 'date' },
      { text: this.$t('forceReservable.text.time'), value: 'time' },
    ]
  }
  dateFmt(val: string) {
    if (!val) return val
    return formatDateForDisplay(val, this.$i18n.locale)
  }
  timeFmt(val: string) {
    if (!val) return val
    return moment(val).format('HH:mm')
  }

  filter: null | Record<string, any> = null

  convertFetchParams(params: Record<string, any>) {
    if (params.dateFrom) {
      params.dateFrom = moment(params.dateFrom)
        .startOf('day')
        .toISOString()
    }
    if (params.dateTo) {
      params.dateTo = moment(params.dateTo)
        .endOf('day')
        .toISOString()
    }
    return params
  }

  updateQuery() {
    if (this.filter !== null) this.listView.updateQuery(this.filter)
  }
}

const extractTime = (value: string | undefined) =>
  value ? moment(value).format('HH:mm') : ''
